import Axios from "axios"
import { errorHandler, generateRequestHeaders } from "../../utils"
import api from "../../api"
import adapter from './adapter'
import { TIMEOUT } from "../../constants"

const service = {
  async getData(id){
    return new Promise(function(resolve, reject){
      const config = {
        // timeout: TIMEOUT,
        headers: generateRequestHeaders()
      }

      Axios.get(api.base+api.events+id+'/', config)
        .then(res => {
          if(res.data.results){
            resolve(res.data.results)
          }
          else if(res.data){
            resolve(res.data)
          }
          else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
    })
  },

  async updateData(id, data){
    return new Promise(function(resolve, reject){
      const config = {
        timeout: TIMEOUT,
        headers: generateRequestHeaders()
      }

      const requestBody = adapter.formToRequestBody(data)

      Axios.put(api.base+api.events+id+'/', requestBody, config)
        .then(res => {
          console.log(res)
          if(res.data.results){
            resolve(res.data.results)
          }
          else if(res.data){
            resolve(res.data)
          }
          else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
    })
  },

  async handleGallery(id, filesByBlob){
    const response = await service.getData(id)
    const event = response.results ? response.results : response
    const { galleries } = event

    return await this.updateGallery(galleries, filesByBlob)
  },

  async updateGallery(data, filesByBlob){
    const result = []

    if(data && data.length > 0){
      for (let index = 0; index < data.length; index++) {
        const { pkGalleryId, deskripsiGambar } = data[index];
        const blob = deskripsiGambar[0]

        if(filesByBlob[blob]){
          const updated = await this.updateGalleryImageDirect(pkGalleryId, filesByBlob[blob])
          result.push({ index, updated })
        }
      }
    }

    return result
  },

  async updateGalleryImageDirect(id, file){
    const formData = new FormData()
    formData.append('imgGambar', file)

    const config = {
      headers: generateRequestHeaders()
    }

    const url = `${api.base}${api.events_gallery}${id}/`
    return Axios.put(url, formData, config)
  },

  async handleGalleryDelete(data){
    const result = []

    if(data && data.length > 0){
      for (let index = 0; index < data.length; index++) {
        const pkId = data[index];

        const updated = await this.deleteGalleryImage(pkId)
        result.push({ index, updated })
      }
    }

    return result
  },

  async deleteGalleryImage(id){
    if(id){
      const config = {
        headers: generateRequestHeaders()
      }

      const url = `${api.base}${api.events_gallery}${id}/`
      return await Axios.delete(url, config)
    }

    return '400 | Gallery ID is not provided.'
  },

  async delete(id){
    return new Promise(function(resolve, reject){
      if(id){
        Axios.delete(`${api.base}${api.events}${id}/`, {
          headers: generateRequestHeaders()
        })
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
